import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import PromotedObject from './ObjectFields/PromotedObject';
import SimpleField from './ObjectFields/SimpleField';
import { parseJSON, toJSON } from '../../utils/helpers';
import Targeting from './ObjectFields/Targeting';
import Creative from './ObjectFields/Creative';
import ImageUrl from './ObjectFields/ImageUrl';
import WebhookField from './ObjectFields/WebhookField';
import BidConstraints from './ObjectFields/BidConstraints';
import AttributionSpec from './ObjectFields/AttributionSpec';

const EditDuplicateCampaign = () => {
  const dispatch = useDispatch();
  const { action_id } = useParams();
  const { action, objectFields } = useSelector((state) => state.general);

  const [formStateActionData, setFormStateActionData] = useState({});
  const [feedSources, setFeedSources] = useState([]); // for DUPLICATE_DIFF_ACCOUNT
  const [budgetLevel, setBudgetLevel] = useState('');
  const [formStateCampaign, setFormStateCampaign] = useState({});
  const [formStateAdSet, setFormStateAdSet] = useState({});
  const [formStateAd, setFormStateAd] = useState({});
  const [formStateCreative, setFormStateCreative] = useState({});

  const feedSourcesTypes = [
    { columnValue: 'sedo', title: 'Sedo' },
    { columnValue: 'SEDO RSOC', title: 'Sedo RSOC' },
    { columnValue: 'PREDICTO RSOC', title: 'Predicto' },
    { columnValue: 'TONIC RSOC', title: 'Tonic' },
    { columnValue: 'PV RSOC', title: 'PV' },
    { columnValue: 'OWN RSOC', title: 'Own Rsoc' },
  ];

  const budgetLevelTypes = ['campaign', 'adset'];

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'action',
        route: `actions/getactionById`,
        actionId: action_id,
      }),
    );
    dispatch(
      apiAction({
        reduxField: 'objectFields',
        route: 'operations/getFacebookObjectFields',
        fields: [
          'facebookCampaignFields',
          'facebookAdsetFields',
          'facebookAdFields',
          'adsetTargetingFields',
          'facebookCreativeFields',
        ],
      }),
    );
  }, [dispatch, action_id]);

  const checkState =
    action?._id &&
    action?.actionData &&
    action?.duplicateCampaignSpecs &&
    action?.duplicateAdsetSpecs &&
    action?.duplicateAdSpecs &&
    action?.duplicateCreativeSpecs &&
    Array.isArray(objectFields?.facebookCampaignFields) &&
    Array.isArray(objectFields?.facebookAdsetFields) &&
    Array.isArray(objectFields?.facebookAdFields) &&
    Array.isArray(objectFields?.adsetTargetingFields) &&
    Array.isArray(objectFields?.facebookCreativeFields)
      ? true
      : false;

  useEffect(() => {
    if (checkState) {
      setFormStateActionData(parseJSON(action.actionData));
      setFeedSources(action.feedSources || []);
      setBudgetLevel(action.budgetLevel || '');
      // Constructing formStateCampaign
      const campaignFields = Object.values(action.duplicateCampaignSpecs).map((field) => {
        return { id: field.id, value: field.value, isUseSource: field.isUseSource };
      });
      const formStateCampaignInitialState = campaignFields.reduce((acc, field) => {
        const objectField = objectFields.facebookCampaignFields.find((objField) => objField.id === field.id);
        const value = !field.value && objectField?.type === 'object' ? {} : field.value;
        acc[field.id] = { ...objectField, id: field.id, value, isUseSource: field.isUseSource };
        return acc;
      }, {});
      setFormStateCampaign(formStateCampaignInitialState);

      // Constructing formStateAdSet
      const adsetFields = Object.values(action.duplicateAdsetSpecs).map((field) => {
        return { id: field.id, value: field.value, isUseSource: field.isUseSource };
      });
      const formStateAdSetInitialState = adsetFields.reduce((acc, field) => {
        const objectField = objectFields.facebookAdsetFields.find((objField) => objField.id === field.id);
        const value = !field.value && objectField?.type === 'object' ? {} : field.value;
        acc[field.id] = { ...objectField, id: field.id, value, isUseSource: field.isUseSource };
        return acc;
      }, {});
      setFormStateAdSet(formStateAdSetInitialState);

      // Constructing formStateAd
      const adFields = Object.values(action.duplicateAdSpecs).map((field) => {
        return { id: field.id, value: field.value, isUseSource: field.isUseSource };
      });
      const formStateAdInitialState = adFields.reduce((acc, field) => {
        const objectField = objectFields.facebookAdFields.find((objField) => objField.id === field.id);
        const value = !field.value && objectField?.type === 'object' ? {} : field.value;
        acc[field.id] = { ...objectField, id: field.id, value, isUseSource: field.isUseSource };
        return acc;
      }, {});
      setFormStateAd(formStateAdInitialState);

      // Constructing formStateCreative
      const creativeFields = Object.values(action.duplicateCreativeSpecs).map((field) => {
        return { id: field.id, value: field.value, isUseSource: field.isUseSource };
      });
      const formStateCreativeInitialState = creativeFields.reduce((acc, field) => {
        const objectField = objectFields.facebookCreativeFields.find((objField) => objField.id === field.id);
        const value = !field.value && objectField?.type === 'object' ? {} : field.value;
        acc[field.id] = { ...objectField, id: field.id, value, isUseSource: field.isUseSource };
        return acc;
      }, {});
      setFormStateCreative(formStateCreativeInitialState);
    }
  }, [dispatch, action, action_id, objectFields, checkState]);

  if (action?._id !== action_id) {
    dispatch(
      generalSet({
        reduxField: 'action',
        value: null,
      }),
    );
  }

  if (!action?._id) {
    return <Spinner />;
  }

  console.log({
    action,
    feedSources,
    formStateActionData,
    formStateCampaign,
    formStateAdSet,
    formStateAd,
    objectFields,
  });

  return checkState ? (
    <>
      <div>
        <Link to='/actions' className='btn btn-outline-dark'>
          All Actions
        </Link>
      </div>
      <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center border-bottom'>
          <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0'>
            <h1>
              Action Details: <span className='text-primary'>{formStateActionData.name}</span>
            </h1>
          </div>
          <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'>
            <h5>
              Action Type: <span className='text-primary'>{action.actionType}</span>
            </h5>
          </div>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6 border p-3'>
            <h6>Action Name</h6>
            <input
              type='text'
              defaultValue={formStateActionData.name}
              className='form-control'
              onBlur={(e) => {
                dispatch(
                  apiAction({
                    reduxField: 'action',
                    route: `actions/updateActionById`,
                    actionId: action_id,
                    actionData: { ...formStateActionData, name: e.target.value },
                  }),
                );
                dispatch(
                  generalSet({
                    reduxField: 'action',
                    value: { ...action, actionData: toJSON({ ...formStateActionData, name: e.target.value }) },
                  }),
                );
              }}
            />
          </div>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6 border p-3 mt-4'>
            <h6>
              {' '}
              <input
                type='checkbox'
                checked={formStateActionData.isDuplicateCampaignFixedBudget ? true : false}
                onChange={(e) => {
                  setFormStateActionData({
                    ...formStateActionData,
                    isDuplicateCampaignFixedBudget: e.target.checked,
                  });
                  dispatch(
                    apiAction({
                      reduxField: 'action',
                      route: `actions/updateActionById`,
                      actionId: action_id,
                      actionData: { ...formStateActionData, isDuplicateCampaignFixedBudget: e.target.checked },
                    }),
                  );
                  dispatch(
                    generalSet({
                      reduxField: 'action',
                      value: {
                        ...action,
                        actionData: toJSON({
                          ...formStateActionData,
                          isDuplicateCampaignFixedBudget: e.target.checked,
                        }),
                      },
                    }),
                  );
                }}
              />{' '}
              Fixed Budget
            </h6>

            <input
              type='number'
              className='form-control mt-2'
              defaultValue={formStateActionData.duplicateCampaignFixedBudget}
              disabled={formStateActionData.isDuplicateCampaignFixedBudget ? false : true}
              onBlur={(e) => {
                dispatch(
                  apiAction({
                    reduxField: 'action',
                    route: `actions/updateActionById`,
                    actionId: action_id,
                    actionData: { ...formStateActionData, duplicateCampaignFixedBudget: e.target.value },
                  }),
                );
                dispatch(
                  generalSet({
                    reduxField: 'action',
                    value: {
                      ...action,
                      actionData: toJSON({ ...formStateActionData, duplicateCampaignFixedBudget: e.target.value }),
                    },
                  }),
                );
              }}
            />
          </div>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6 border p-3 mt-4'>
            <h6>Naming Prefix</h6>
            <input
              type='text'
              defaultValue={formStateActionData.namingPrefix}
              placeholder='Prefix...'
              className='form-control'
              disabled={formStateActionData.isNamingPrefix ? false : true}
              onBlur={(e) => {
                dispatch(
                  apiAction({
                    reduxField: 'action',
                    route: `actions/updateActionById`,
                    actionId: action_id,
                    actionData: { ...formStateActionData, namingPrefix: e.target.value },
                  }),
                );
                dispatch(
                  generalSet({
                    reduxField: 'action',
                    value: { ...action, actionData: toJSON({ ...formStateActionData, namingPrefix: e.target.value }) },
                  }),
                );
              }}
            />
            <input
              type='checkbox'
              className='mt-2'
              checked={formStateActionData.isNamingPrefix ? true : false}
              onChange={(e) => {
                setFormStateActionData({
                  ...formStateActionData,
                  isNamingPrefix: e.target.checked,
                });
                dispatch(
                  apiAction({
                    reduxField: 'action',
                    route: `actions/updateActionById`,
                    actionId: action_id,
                    actionData: { ...formStateActionData, isNamingPrefix: e.target.checked },
                  }),
                );
                dispatch(
                  generalSet({
                    reduxField: 'action',
                    value: {
                      ...action,
                      actionData: toJSON({ ...formStateActionData, isNamingPrefix: e.target.checked }),
                    },
                  }),
                );
              }}
            />{' '}
            Use Naming Prefix
          </div>
        </div>
        {
          // If Action Type is DUPLICATE_DIFF_ACCOUNT
          action.actionType === 'DUPLICATE_DIFF_ACCOUNT' ? (
            <>
              <div className='row d-flex justify-content-center mt-4'>
                <div className='col-md-6 border p-3'>
                  <h6>Feed Sources</h6>
                  {feedSourcesTypes.map((feedSource) => {
                    const exists = feedSources.find((source) => source.columnValue === feedSource.columnValue);
                    return (
                      <button
                        key={`feedSource_${feedSource.columnValue}`}
                        className={`btn btn${exists ? '' : '-outline'}-primary mr-2`}
                        onClick={() => {
                          let changes = [];
                          if (exists) {
                            changes = feedSources.filter((source) => source.columnValue !== feedSource.columnValue);
                          } else {
                            changes = [...feedSources, feedSource];
                          }
                          setFeedSources(changes);
                          dispatch(
                            apiAction({
                              reduxField: 'action',
                              route: `actions/updateDuplicateAction`,
                              actionId: action._id,
                              fieldName: 'feedSources',
                              changes,
                            }),
                          );
                        }}
                      >
                        {feedSource.title}
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className='row d-flex justify-content-center mt-4'>
                <div className='col-md-6 border p-3'>
                  <h6>Budget Level</h6>
                  {budgetLevelTypes.map((bl) => {
                    return (
                      <button
                        className={`btn btn${bl === budgetLevel ? '' : '-outline'}-primary mr-2`}
                        onClick={() => {
                          setBudgetLevel(bl);
                          dispatch(
                            apiAction({
                              reduxField: 'action',
                              route: `actions/updateDuplicateAction`,
                              actionId: action._id,
                              fieldName: 'budgetLevel',
                              changes: bl,
                            }),
                          );
                        }}
                      >
                        {typeof bl === 'string' ? bl[0].toLocaleUpperCase() + bl.replace(bl[0], '') : ''}
                      </button>
                    );
                  })}
                </div>
              </div>
            </>
          ) : null
        }
        <div className='row d-flex justify-content-center mt-4'>
          <h3>
            <span className='text-primary'>Campaign Settings</span>
          </h3>
        </div>
        <div className='row d-flex justify-content-center mt-4 border-bottom'>
          {objectFields.facebookCampaignFields.map((field) => {
            if (field.id === 'promoted_object')
              return (
                <PromotedObject
                  key={`duplicateCampaignSpecs_${field.id}`}
                  action={action}
                  fieldName={'duplicateCampaignSpecs'}
                  field={field}
                  state={formStateCampaign}
                  setState={setFormStateCampaign}
                />
              );

            return (
              <SimpleField
                key={`duplicateCampaignSpecs_${field.id}`}
                action={action}
                fieldName={'duplicateCampaignSpecs'}
                field={field}
                state={formStateCampaign}
                setState={setFormStateCampaign}
              />
            );
          })}
        </div>

        {/* Adset Settings */}
        <div className='row d-flex justify-content-center mt-4'>
          <h3>
            <span className='text-primary'>Adset Settings</span>
          </h3>
        </div>
        <div className='row d-flex justify-content-center mt-4 border-bottom'>
          {objectFields.facebookAdsetFields.map((field) => {
            if (field.id === 'attribution_spec')
              return (
                <AttributionSpec
                  key={`duplicateAdsetSpecs_${field.id}`}
                  action={action}
                  fieldName={'duplicateAdsetSpecs'}
                  field={field}
                  state={formStateAdSet}
                  setState={setFormStateAdSet}
                />
              );
            if (field.id === 'promoted_object')
              return (
                <PromotedObject
                  key={`duplicateAdsetSpecs${field.id}`}
                  action={action}
                  fieldName={'duplicateAdsetSpecs'}
                  field={field}
                  state={formStateAdSet}
                  setState={setFormStateAdSet}
                />
              );
            if (field.id === 'targeting')
              return (
                <Targeting
                  key={`duplicateAdsetSpecs_${field.id}`}
                  action={action}
                  fieldName={'duplicateAdsetSpecs'}
                  objectField={'facebookAdsetFields'}
                  field={field}
                  state={formStateAdSet}
                  setState={setFormStateAdSet}
                  adsetTargetingFields={objectFields.adsetTargetingFields}
                />
              );
            if (field.id === 'bid_constraints') {
              return (
                <BidConstraints
                  key={`duplicateAdsetSpecs_${field.id}`}
                  action={action}
                  fieldName={'duplicateAdsetSpecs'}
                  objectField={'facebookAdsetFields'}
                  field={field}
                  state={formStateAdSet}
                  setState={setFormStateAdSet}
                  adsetTargetingFields={objectFields.adsetTargetingFields}
                />
              );
            }

            return (
              <SimpleField
                key={`duplicateAdsetSpecs_${field.id}`}
                action={action}
                fieldName={'duplicateAdsetSpecs'}
                field={field}
                state={formStateAdSet}
                setState={setFormStateAdSet}
              />
            );
          })}
        </div>

        {/* Ad Settings */}
        <div className='row d-flex justify-content-center mt-4'>
          <h3>
            <span className='text-primary'>Ad Settings</span>
          </h3>
        </div>
        <div className='row d-flex justify-content-center mt-4 border-bottom'>
          {objectFields.facebookAdFields.map((field) => {
            if (field.id === 'targeting')
              return (
                <Targeting
                  key={`duplicateAdSpecs_${field.id}`}
                  action={action}
                  fieldName={'duplicateAdSpecs'}
                  objectField={'facebookAdFields'}
                  field={field}
                  state={formStateAd}
                  setState={setFormStateAd}
                  adsetTargetingFields={objectFields.adTargetingFields}
                />
              );
            if (field.id === 'creative')
              return (
                <Creative
                  key={`duplicateAdSpecs${field.id}`}
                  action={action}
                  fieldName={'duplicateAdSpecs'}
                  field={field}
                  state={formStateAd}
                  setState={setFormStateAd}
                />
              );
            return (
              <SimpleField
                key={`duplicateAdSpecs${field.id}`}
                action={action}
                fieldName={'duplicateAdSpecs'}
                field={field}
                state={formStateAd}
                setState={setFormStateAd}
              />
            );
          })}
        </div>

        {/* Ad Settings */}
        {!formStateAd?.creative?.isUseSource ? (
          <>
            <div className='row d-flex justify-content-center mt-4'>
              <h3>
                <span className='text-primary'>Creative</span>
              </h3>
            </div>
            <div className='row d-flex justify-content-center mt-4 border-bottom'>
              {objectFields.facebookCreativeFields.map((field) => {
                if (field.id === 'image_url')
                  return (
                    <ImageUrl
                      key={`duplicateCreativeSpecs${field.id}`}
                      action={action}
                      fieldName={'duplicateCreativeSpecs'}
                      field={field}
                      state={formStateCreative}
                      setState={setFormStateCreative}
                    />
                  );

                if (field.id === 'image_hash' && action?.duplicateCreativeSpecs?.image_url?.isUseSource === false)
                  return null;

                if (field.id === 'object_story_spec' || field.id === 'body')
                  return (
                    <WebhookField
                      key={`duplicateCreativeSpecs${field.id}`}
                      action={action}
                      fieldName={'duplicateCreativeSpecs'}
                      field={field}
                      state={formStateCreative}
                      setState={setFormStateCreative}
                    />
                  );

                return (
                  <SimpleField
                    key={`duplicateCreativeSpecs${field.id}`}
                    action={action}
                    fieldName={'duplicateCreativeSpecs'}
                    field={field}
                    state={formStateCreative}
                    setState={setFormStateCreative}
                  />
                );
              })}
            </div>
          </>
        ) : null}
      </div>
    </>
  ) : (
    <Spinner />
  );
};

export default EditDuplicateCampaign;
